import { useId, useEffect } from 'react';

function useA11y(props, containerRef, togglerRef) {
  const id = `tooltip-${useId()}`;
  useEffect(() => {
    const toggler = containerRef?.current ?? togglerRef?.current;
    if (!toggler || props.disabled) {
      return;
    }
    if (props.ariaType === "label") {
      toggler.setAttribute("aria-labelledby", id);
    } else if (props.ariaType === "description") {
      toggler.setAttribute("aria-describedby", id);
    }
    return () => {
      if (props.ariaType === "label") {
        toggler.removeAttribute("aria-labelledby");
      } else if (props.ariaType === "description") {
        toggler.removeAttribute("aria-describedby");
      }
    };
  }, [togglerRef, containerRef, id, props.ariaType, props.disabled]);
  return id;
}

export { useA11y };
//# sourceMappingURL=hook.a11y.js.map
